import axios from 'axios';
import { API_URL } from "../constantes/constantes";

/**
 * Obtiene los datos de la tabla de posiciones para un deporte específico
 * Maneja diferentes deportes con URLs específicas y configuración de timeout
 * 
 * @param {Object} params - Parámetros de la función
 * @param {string} params.sport - Tipo de deporte ('baseball' o cualquier otro)
 * @param {string|number} params.idEvent - ID del evento/liga para obtener posiciones
 * 
 * @returns {Promise<Object>} Objeto con los datos y código de estado
 * @returns {Object} returns.data - Datos de la tabla de posiciones
 * @returns {number} returns.statusCode - Código de estado HTTP de la respuesta
 * 
 * @example
 * // Obtener tabla de fútbol
 * const result = await getPositionsTable({ sport: 'soccer', idEvent: 123 });
 * 
 * @example
 * // Obtener tabla de baseball (usa ID fijo)
 * const result = await getPositionsTable({ sport: 'baseball', idEvent: 456 });
 */
export async function getPositionsTable({ sport, idEvent }) {

  /**
   * Construye la URL de la API según el tipo de deporte
   * Baseball usa un ID fijo (7), otros deportes usan el idEvent proporcionado
   */
  let apiURL;
  apiURL = `${API_URL}league/${sport}/standing/${idEvent}.json`;

  try {
    // Realizar petición HTTP con configuración de timeout y headers
    const { data, status } = await axios.get(apiURL, {
      timeout: 25000, // 25 segundos de timeout
      headers: {
        'Accept': 'application/json, text/plain, */*'
      }
    });

    return {
      data,
      statusCode: status
    };

  } catch (error) {
    // Manejo de errores con logging y respuesta estructurada
    console.error("Error en getPositionsTable:", error.message || error);

    const statusCode = error.response?.status || 500;

    return {
      statusCode,
      data: [] // Array vacío como fallback
    };
  }
}